<template>
        <div class="templete">
            <div class="search_box clearfix StockSearch">
                <el-input class="search_input search_inputBox" v-model="params.keyword" placeholder="公司名称/联系电话" size="mini"></el-input>
                <el-select class="search_select search_inputBox" v-model="params.purchaser_id" multiple collapse-tags placeholder="所属人" @visible-change="getSelectList('user')">
                    <el-option v-for="list in selectMap.user" :key="list.id" :value="list.id" :label="list.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.province_id" placeholder="省份" size="mini" @change="searchChangePro">
                    <el-option v-for="pro in proList" :key="pro.id" :value="pro.id" :label="pro.name"></el-option>
                </el-select>
                <el-select class="search_select search_inputBox" v-model="params.city_id" placeholder="城市" size="mini">
                    <el-option v-for="city in searchCityList" :key="city.id" :value="city.id" :label="city.name"></el-option>
                </el-select>
                <el-input class="search_select search_inputBox" v-model="params.main_business" placeholder="主营项目" size="mini"></el-input>
                <div class="reset fcolor" @click="reset">重置</div>
                <el-button  class="publicBtn" @click="getList(true)">查询</el-button>
            </div>
            <div class="tableBox selectStockTable">
                <tabletem :isLoading="tableLoading" :tablecol="tableCol" :tabledata="list" @getRow="getRow" :selecttype="1" @rowClick="rowClick"></tabletem>
            </div>
            <div class="pageBox">
                <pagination ref="pagination" :lastpages.sync="last_page" :currentpages.sync="params.page" :all.sync="total" :pagesizes.sync="params.per_page" @getPage="getPage"></pagination>
            </div>
            <div class="btnList clearfix">
                <div class="btnBox">
                    <el-button  class="funcPublicBtn" @click="cancel">取消</el-button>
                    <!-- <el-button  class="funcPublicBtn" @click="selectData">选中</el-button> -->
                    <el-button  class="funcPublicBtn funcPublicBtnChecked" @click="selectAndOut">选中并退出</el-button>
                </div>
            </div>
        </div>
</template>
<script>
    import tabletem from './table.vue'
    import pagination from './pagination.vue'
    export default {
        props:['saleman'],
        data(){
            return{
                tableLoading:false,
                params:{
                    keyword: "",
                    purchaser_id:[],
                    province_id: "",
                    city_id: "",
                    per_page: 50,
                    page:1
                },
                proList:[],
                cityList:[],
                searchCityList:[],
                selectMap:{
                    user:[],
                },
                last_page:1,
                total:0,
                selectRow:[],
                list:[],
                tableCol:[	
                    {colName:"供应商名称",colKey:"name",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系人",colKey:"linkman",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"联系电话",colKey:"phone",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"主营业务",colKey:"main_business",colWidth:100,isSetWidth:true,isCanClick:false,isShow:true},
                    {colName:"备注",colKey:"remark",colWidth:150,isSetWidth:true,isCanClick:false,isShow:true}
                ]
            }
        },
        created(){
            this.getSelectList("user")
            this.getArea().then(resolve=>{
                this.proList=resolve.data.data;
            })
            this.getList()
        },
        methods:{
            getSelectList(target){
                this.$getSelectList(target).then(res=>{
                    this.selectMap[res.target]=res.list;
                })
            },
            searchChangePro(val){
                this.getArea(val).then(resolve=>{
                    this.searchCityList=resolve.data.data;
                    this.params.city_id="";
                })
            },
            changePro(val){
                this.getArea(val).then(resolve=>{
                    this.cityList=resolve.data.data;
                    this.form_params.city_id="";
                })
            },
            cancel(){
                this.$emit("cancel")
            },
            // selectData(){
            //     this.$emit("selectData",this.selectRow)
            // },
            selectAndOut(){
                this.$emit("selectAndOut",this.selectRow)
            },
            reset(){
                this.params=this.resetSearch(this.params)
                this.params.salesman_id=[this.saleman];
                this.getList();
            },
            getList(flag){
                if(flag){
                    this.params.page = 1;
                }
                this.tableLoading = true;
                this.postFunc("erp/supplier.list",this.params,res=>{
                    this.last_page=parseInt(res.data.data.last_page);
                    // this.params.page=parseInt(res.data.data.current_page);
                    this.$refs.pagination.flag = true;
                    this.tableLoading = false;
                    this.total=parseInt(res.data.data.total);
                    this.list=res.data.data.data;
                },error=>{
                    this.tip(error.data.message,"warning")
                })
            },
            getPage(obj){
                this.params.page=obj.currentpage;
				this.params.per_page=obj.pagesize;
            },
            rowClick(){},
            getRow(row){
                this.selectRow=row;   
            }
        },
        components:{
            tabletem,
            pagination
        },
        watch:{
            "params.page":function(){
                this.getList();
            },
            "params.per_page":function(){
                this.getList();
            },
            "saleman":function(val){
                this.params.salesman_id = [val];
                this.getList();
            }
        }
    }
</script>
<style scoped>
    .pageAssembly .pageSize{margin-top:3px;}
    .totalBox{float: left;}
    .totalBox .total{float: left;font-size: 12px;line-height: 33px;margin-right:15px;}
    .btnBox{float: right;}
</style>